export default __webpack_public_path__ + "static/media/LocationUser.8cfee601.png";